import { ActionType } from 'typesafe-actions'
import * as actions from '../actions/app/e3dSharingDashboard.actions'

export type E3DSharingDashboardState = {
    isVisible: boolean
    shouldAutoDisplay: boolean
}

export const defaultState: E3DSharingDashboardState = {
    isVisible: false,
    shouldAutoDisplay: false,
}

type E3DSharingDashboardAction = ActionType<typeof actions>

const e3dSharingDashboardReducer = (
    state: E3DSharingDashboardState = defaultState,
    action: E3DSharingDashboardAction,
): E3DSharingDashboardState => {
    switch (action.type) {
        case 'DOC / E3DSharingDashboard / SHOW':
            return { ...state, isVisible: true, shouldAutoDisplay: false }
        case 'DOC / E3DSharingDashboard / HIDE':
            return { ...state, isVisible: false, shouldAutoDisplay: false }
        case 'DOC / E3DSharingDashboard / SET_SHOULD_AUTO_DISPLAY':
            return { ...state, shouldAutoDisplay: action.payload }
        default:
            return state
    }
}

export default e3dSharingDashboardReducer
